export const GET_USER_WINES = 'GET_USER_WINES';
